import { useCallback, useMemo } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translationService } from '../services/translationService';

export function useTranslation() {
  const { currentLanguage } = useLanguage();

  const t = useCallback(
    (key, params = {}) => translationService.t(key, currentLanguage, params),
    [currentLanguage]
  );

  const getAvailableLanguages = useCallback(
    () => translationService.getAvailableLanguages(),
    []
  );

  const getLanguageName = useCallback(
    (code) => translationService.getLanguageName(code),
    []
  );

  const getLanguageOptions = useCallback(
    () => translationService.getLanguageOptions(),
    []
  );

  const hasTranslation = useCallback(
    (key) => translationService.hasTranslation(key, currentLanguage),
    [currentLanguage]
  );

  const getAllTranslations = useCallback(
    (key) => translationService.getAllTranslations(key),
    []
  );

  return useMemo(() => ({
    t,
    currentLanguage,
    getAvailableLanguages,
    getLanguageName,
    getLanguageOptions,
    hasTranslation,
    getAllTranslations
  }), [
    t,
    currentLanguage,
    getAvailableLanguages,
    getLanguageName,
    getLanguageOptions,
    hasTranslation,
    getAllTranslations
  ]);
}
